import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../config';

export default function ReportExporter({ videoId, videos }) {
  const [generating, setGenerating] = useState(false);
  const [report, setReport]         = useState(null);

  const completedVideos = videos.filter(v => v.status === 'complete');
  const targetId = videoId || completedVideos[0]?.id;

  const generatePDF = async () => {
    if (!targetId) return;
    setGenerating(true);
    setReport(null);
    try {
      const { data } = await axios.post(`${API}/reports/generate/${targetId}`);
      setReport(data);
    } finally {
      setGenerating(false);
    }
  };

  const downloadCSV = () => {
    if (!targetId) return;
    window.open(`${API}/reports/csv/${targetId}`, '_blank');
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="text-xs text-slate-500 uppercase tracking-wide font-semibold">
        Export Reports
      </div>

      {completedVideos.length === 0 && (
        <div className="text-xs text-slate-600 text-center py-2">
          Process a video to enable reports
        </div>
      )}

      <button onClick={generatePDF}
        disabled={!targetId || generating}
        className="w-full py-1.5 px-3 bg-indigo-700 hover:bg-indigo-600
                   disabled:opacity-40 text-white text-xs font-medium rounded-lg
                   transition-colors flex items-center justify-center gap-2">
        {generating ? '⏳ Generating…' : '📤 Generate PDF Report'}
      </button>

      <button onClick={downloadCSV}
        disabled={!targetId}
        className="w-full py-1.5 px-3 bg-teal-700 hover:bg-teal-600
                   disabled:opacity-40 text-white text-xs font-medium rounded-lg
                   transition-colors flex items-center justify-center gap-2">
        📋 Export CSV
      </button>

      {report && (
        <a href={`${API}/reports/${report.filename}/download`}
          className="w-full py-1.5 px-3 bg-green-700 hover:bg-green-600 text-white text-xs
                     font-medium rounded-lg transition-colors flex items-center justify-center gap-2 mt-1"
          download={report.filename}>
          ⬇ Download PDF
        </a>
      )}
    </div>
  );
}
